<template>
  <div class="ty-main">
    <div class="ty-content white">
      <el-form :inline="true" @submit.native.prevent>
       <el-form-item label="已离职成员:">
          <el-input
            v-model="employee"
            placeholder="请选择离职成员"
            @focus="openSelectDialog"
            clearable
            @clear="reset"
          ></el-input>
        </el-form-item>
      <!--  <el-form-item label="已离职成员：">
          <el-input
            v-model="employee"
            placeholder="请输入离职成员名称"
            clearable
            @input="onSearch"
          ></el-input>
        </el-form-item>
        <div class="fr">
          <el-button
            type="primary"
            @click="refresh"
            :loading="refurbish02"
            :disabled="isAllowRefresh"
            >{{ isAllowRefresh ? '刷新中...' : '刷新' }}</el-button
          >
        </div> -->
      </el-form>
      <el-table :data="tableData" style="width: 100%;" id="table">
        <el-table-column label="已离职成员" fixed width="300">
           <template slot-scope="scope">
           <div v-if="scope.row.name.length > 0">
              <el-popover
                v-if="scope.row.name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></div>
                <span slot="reference" style="color: #303133;">{{scope.row.name | ellipsis}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
              </el-popover>
              <span v-else>{{scope.row.name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                  <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                  <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="department_name" label="所属部门" min-width="334">
          <template slot-scope="scope">
            <div v-if="scope.row.department_name.length > 0">
              <el-popover
                v-if="scope.row.department_name.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.department_name}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.department_name}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="assign_time" label="离职时间" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.quit_time ? scope.row.quit_time : '-'}}</span>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>
      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="选择已离职成员" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid #D8DCE1;">
          <el-card class="box-card" :body-style="{height: '460px', overflow: 'auto' }" shadow="never">
            <el-input
              class="filter-input"
              placeholder="输入已离职人员"
              v-model="filterText"
              size="small"
              clearable
            >
            </el-input>
            <el-tree
              ref="tree"
              :data="treeData"
              node-key="staff_id"
              :props="defaultProps"
              :check-on-click-node="true"
              @check-change="getChecked"
              :filter-node-method="filterNode"
            >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span style="margin-left: -25px;">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                {{ node.label }}<span
                      v-if="node.checked && node.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
              </span>
            </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="12">
        <el-card class="box-card" :body-style="{height: '460px', overflow: 'auto' }" shadow="never">
          <div class="xuanze">已选择的员工</div>
            <ul class="infinite-list">
              <li class="cich" v-for="item in checkedDimission" :key="item.staff_id">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
                </div>
              <!--  <i style="margin-left:170px;" class="el-icon-close"></i> -->
              </li>
            </ul>
          </el-card>
          <!--<el-card class="box-card" shadow="never">
            <div>已选择的员工</div>
            <el-tag
              v-for="item in checkedDimission"
              :key="item.id"
              :disable-transitions="false"
              @close="employeeClose(item)"
            >
              {{ item.name }}
            </el-tag>
          </el-card> -->
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="isSelectDialog = false">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { isAllowRefresh } from '@/utils/util'
export default {
  data() {
    this.selectedList = []
    return {
      tabs: ['离职未被继承成员', '离职已继承成员', '离职无资产成员'],
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'checkTitle'
      },
      total: 0,
      disabled2: true,
      isSelectDialog: false,
      loading: false,
      employee: '',
      refurbish02: false,
      filterText: '',
      checkedDimission: [],
      isAllowRefresh: isAllowRefresh()
    }
  },
  mounted() {
    this.getList()
    this.getlistAll()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  methods: {
    getList(employeeId) {
      this.loading = true
      this.$api
        .get('/api/v1/inherit/no-assets', {
          page: this.currentPage,
          user_id: employeeId
        })
        .then(res => {
          this.total = res.total
          this.$emit('getTotal', res.total)
          this.tableData = res.list
          this.loading = false
        })
    },

    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    onSearch(name) {
      this.getList({
        name
      })
    },
    refresh() {
      this.refurbish02 = true
      const params = {
        type: 3
      }
      this.$api
        .post('/api/v1/inherit/refresh-transfer', params)
        .then(res => {
        })
        this.renovate()
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.checkTitle.indexOf(value) !== -1
    },
    // employeeClose(value) {
    //   this.$refs.tree.setChecked(value.id, false)
    // },
    employeeClose(value) {
      this.checkedDimission.some((item, i) => {
        if (item.staff_id === value.staff_id) {
          this.checkedDimission.splice(i, 1)
          this.$refs.tree.setChecked(value.staff_id, false)
        }
      })
    },
    renovate() {
      const params = {
        type: 3
      }
      this.$api
        .get('/api/v1/get/refresh/status', params)
        .then(() => {
          this.$message.success('刷新成功')
          this.refurbish02 = false
          this.isAllowRefresh = false
        })
        .catch(() => {
          // this.$message.error('刷新失败！')
        })
    },
     // 获取离职部门员工
    getlistAll() {
      const params = {
        type: 3,
        page: 1,
        limit: 9999
      }
      this.$api.get('/api/v1/inherit/quit-department-staff', params).then(response => {
        let res = response
        if (response && typeof response === 'string') {
          res = JSON.parse(response)
        }

        const treeData = res || []
        treeData.forEach(v => {
          if (v.name === null) {
             v.checkTitle = '未知员工'
          } else {
             v.checkTitle = `${v.name} - ${v.department_name}`
          }
        })
        this.treeData = treeData || []
      })
    },
    getChecked(value, isCheck) {
      const checkedDimission = this.checkedDimission
      if (isCheck) {
         checkedDimission.push({
          staff_id: value.staff_id,
          name: value.name
        })
      } else {
        checkedDimission.forEach((item, i) => {
          if (item.staff_id === value.staff_id) {
            checkedDimission.splice(i, 1)
          }
        })
      }
      this.checkedDimission = checkedDimission
    },
     reset() {
      this.currentPage = 1
      this.employee = ''
      this.getList()
    },
    reLoadTable() {
      const employee = []
      const employeeId = []
      this.checkedDimission.forEach(v => {
        employee.push(v.name)
        employeeId.push(v.staff_id)
      })
      this.employee = employee.join('，')
      this.currentPage = 1
      this.getList(employeeId)
      this.isSelectDialog = false
    //  this.$refs.selectionChangae.clearSelection()
    },
     openSelectDialog() {
      this.isSelectDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ty-card {
  padding-bottom: 5px;
}
.el-card {
  position: relative;
  overflow: auto;
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}
.el-button--primary{
  width: 80px;
  height: 40px;
  font-size: 15px;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep .el-dialog__body{
  padding: 0;
}
.el-button--primary.is-disabled{
  opacity: 0.7;
}
</style>
